module.exports = __webpack_public_path__ + "static/media/unmute.6f3fc422.svg";